var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-content" },
    [
      _c(
        "el-header",
        [
          _c(
            "span",
            { staticClass: "op-left" },
            [
              _c("label", [_vm._v("产品型号：")]),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  staticClass: "el-select el-select-group",
                  model: {
                    value: _vm.defaultProduct,
                    callback: function ($$v) {
                      _vm.defaultProduct = $$v
                    },
                    expression: "defaultProduct",
                  },
                },
                _vm._l(_vm.productList, function (op, value) {
                  return _c("el-option", {
                    key: value,
                    attrs: { label: op.text, value: op.value },
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c("el-button", { staticClass: "el-button--primary" }, [
                _vm._v("查询"),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-button", { staticClass: "el-button--primary add-btn" }, [
            _vm._v("添加设备"),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        { attrs: { data: _vm.deviceList, stripe: "", border: "" } },
        [
          _c("el-table-column", {
            attrs: { prop: "id", label: "序号", align: "center" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "name", label: "设备名称", align: "center" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "model", label: "产品型号", align: "center" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "connStyle", label: "连接方式", align: "center" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "addr", label: "地址", align: "center" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "port", label: "端口", align: "center" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              fixed: "right",
              label: "操作",
              align: "center",
              width: "180px",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-button", { on: { click: function ($event) {} } }, [
                      _vm._v("编辑"),
                    ]),
                    _vm._v(" "),
                    _c("el-button", { on: { click: function ($event) {} } }, [
                      _vm._v("删除"),
                    ]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }